module.exports = __webpack_public_path__ + "img/1.50e7536.webp";